<template>
  <main id="ts-main">
    <div
      v-if="loading"
      style="
        width: 100%;
        height: 100%;
        position: fixed;
        background: white;
        z-index: 998;
        top: 0;
        opacity: 0.8;
      "
    >
      <div style="margin-top: 300px">
        <PulseLoader color="#8D600A" />
      </div>
    </div>

    <!--PAGE TITLE
            =========================================================================================================-->
    <section id="page-title">
      <div class="container">
        <div class="row">
          <div class="offset-lg-1 col-lg-10">
            <div class="ts-title">
              <h1>建立新動態</h1>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--SUBMIT FORM
            =========================================================================================================-->
    <section id="submit-form">
      <div class="container">
        <div class="row">
          <div class="offset-lg-1 col-lg-10">
            <div id="form-submit" class="ts-form">
              <!--ALERT
                                =====================================================================================-->

              <!--BASIC INFORMATION
                                =====================================================================================-->
              <section id="basic-information" class="mb-5" hidden>
                <!--Title-->
                <h3 class="text-muted border-bottom">Basic Information</h3>

                <!--Row-->
                <div class="row">
                  <!--Title-->
                  <div class="col-sm-8">
                    <div class="form-group">
                      <label for="title">Title</label>
                      <input
                        type="text"
                        class="form-control"
                        id="title"
                        name="title"
                        required
                      />
                    </div>
                  </div>

                  <!--Price-->
                  <div class="col-sm-4">
                    <div class="input-group">
                      <label for="price">Price</label>
                      <input
                        type="text"
                        class="form-control border-right-0"
                        id="price"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text bg-white border-left-0"
                          >$</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-4">
                    <div class="row">
                      <!--Area-->
                      <div class="col">
                        <div class="input-group">
                          <label for="area">Area</label>
                          <input
                            type="text"
                            class="form-control border-right-0"
                            id="area"
                          />
                          <div class="input-group-append">
                            <span
                              class="input-group-text bg-white border-left-0"
                              >m<sup>2</sup></span
                            >
                          </div>
                        </div>
                      </div>

                      <!--Rooms-->
                      <div class="col">
                        <div class="form-group">
                          <label for="rooms">Rooms</label>
                          <input
                            type="number"
                            class="form-control"
                            id="rooms"
                            name="rooms"
                            min="0"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <!--end row-->
                  </div>
                  <!--end col-md-4-->

                  <!--Type Select-->
                  <div class="col-sm-6 col-md-4">
                    <div class="form-group">
                      <label for="type">Type</label>
                      <select class="custom-select" id="type" name="type">
                        <option value="">Select Type</option>
                        <option value="1">Apartment</option>
                        <option value="2">Villa</option>
                        <option value="3">Land</option>
                        <option value="4">Garage</option>
                      </select>
                    </div>
                  </div>

                  <!--Status Select-->
                  <div class="col-sm-6 col-md-4">
                    <div class="form-group">
                      <label for="status">Status</label>
                      <select class="custom-select" id="status" name="status">
                        <option value="">Select Status</option>
                        <option value="1">Sale</option>
                        <option value="2">Rent</option>
                      </select>
                    </div>
                  </div>
                </div>
                <!--end row-->
              </section>

              <!--LOCATION
                                =====================================================================================-->
              <section id="location" class="mb-5">
                <!--Title-->
                <h3 class="text-muted border-bottom">動態資料</h3>

                <div class="row">
                  <!--Map-->
                  <div class="col-sm-6">
                    <google-map
                      id="map"
                      ref="Map"
                      :center="nowlocation"
                      :zoom="nowzoom"
                      mapTypeId="roadmap"
                      :options="{
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: true,
                        fullscreenControl: true,
                        disableDefaultUi: false,
                      }"
                      style="width: 100%; height: 400px"
                    >
                      <google-map-marker
                        title=""
                        label=""
                        :clickable="false"
                        :draggable="true"
                        :visible="true"
                        :position="nowlocation"
                        :icon="{
                          url: mapicon,
                        }"
                        @dragend="handledrag"
                      ></google-map-marker>
                    </google-map>
                    <!-- <google-map-autocomplete
                      :model="autocompleteinput"
                      placeholder="尋找地點"
                      :controls="false"
                      style="margin-right: 60px"
                    ></google-map-autocomplete> -->
                  </div>
                  <!--end col-md-6-->
                  <div class="col-sm-6">
                    <!--Address-->

                    <div class="input-group">
                      <label>地址</label>
                      <!-- <input
                        type="text"
                        class="form-control border-right-0"
                        id="inputaddress"
                        v-model="autocompleteinput"
                      /> -->

                      <vue-google-autocomplete
                        types=""
                        id="mapautofill2"
                        classname="form-control border-right-0"
                        placeholder="輸入地點"
                        :country="['hk']"
                        v-on:placechanged="getAddressData"
                        v-on:change="locationnamechange"
                      >
                      </vue-google-autocomplete>

                      <div
                        class="input-group-append"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Find My Location"
                      >
                        <a
                          v-on:click="getmylocation"
                          style="cursor: pointer"
                          class="input-group-text bg-white border-left-0"
                        >
                          <i class="fa fa-map-marker ts-text-color-primary"></i>
                        </a>
                      </div>
                    </div>

                    <!--City-->

                    <div class="input-group">
                      <label>日期</label>
                      <input
                        v-model="date"
                        type="text"
                        class="form-control"
                        id="dateinput"
                        required
                      />
                      <div
                        class="input-group-append"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Find My Location"
                      >
                        <a
                          style="cursor: pointer"
                          v-on:click="opendatepicker = !opendatepicker"
                          class="input-group-text bg-white border-left-0"
                        >
                          <i class="fa fa-calendar ts-text-color-primary"></i>
                        </a>
                      </div>
                    </div>

                    <v-date-picker
                      v-model="date"
                      no-title
                      scrollable
                      color="#8d600a"
                      v-if="opendatepicker"
                      style="margin-bottom: 20px"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="opendatepicker = false"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>

                    <!--State-->
                    <div class="input-group">
                      <label for="state">開始時間</label>
                      <input
                        class="form-control"
                        v-model="picker1"
                        @change="checkpicker1"
                        required
                      />
                      <div
                        class="input-group-append"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Find My Location"
                      >
                        <a
                          style="cursor: pointer"
                          v-on:click="openpicker1 = !openpicker1"
                          class="input-group-text bg-white border-left-0"
                        >
                          <i class="fa fa-clock ts-text-color-primary"></i>
                        </a>
                      </div>
                    </div>

                    <v-time-picker
                      v-if="openpicker1"
                      style="margin-bottom: 20px"
                      no-title
                      v-model="picker1"
                      color="#8d600a"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="openpicker1 = false">
                        OK
                      </v-btn></v-time-picker
                    >

                    <!--ZIP-->
                    <div class="input-group">
                      <label for="zip">預計結束時間</label>
                      <input
                        v-model="picker2"
                        class="form-control"
                        @change="checkpicker2"
                        required
                      />
                      <div
                        class="input-group-append"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Find My Location"
                      >
                        <a
                          style="cursor: pointer"
                          v-on:click="openpicker2 = !openpicker2"
                          class="input-group-text bg-white border-left-0"
                        >
                          <i class="fa fa-clock ts-text-color-primary"></i>
                        </a>
                      </div>
                    </div>

                    <v-time-picker
                      v-if="openpicker2"
                      style="margin-bottom: 20px"
                      no-title
                      v-model="picker2"
                      color="#8d600a"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="openpicker2 = false">
                        OK
                      </v-btn></v-time-picker
                    >
                  </div>
                  <!--end col-md-6-->
                </div>
                <!--end row-->
              </section>
              <!--end #location-->

              <section id="additional-information" class="mb-5">
                <!--Title-->
                <h3 class="text-muted border-bottom">補充資料</h3>
                <img id="photopreview" style="max-width: 500px" />
                <!--Description-->
                <div class="form-group">
                  <div class="file-upload-previews"></div>
                  <div class="file-upload">
                    <input
                      id="photoupload"
                      type="file"
                      class="file-upload-input with-preview"
                    />
                    <span><i class="fa fa-plus-circle"></i>上傳照片</span>
                  </div>
                </div>

                <div class="form-group">
                  <!-- <label for="description">Description</label> -->
                  <textarea
                    v-model="description"
                    class="form-control"
                    id="description"
                    rows="4"
                    name="description"
                  ></textarea>
                </div>

                <!--Row-->
                <div class="row" hidden>
                  <!--Bedrooms-->
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="bedrooms">Bedrooms</label>
                      <input
                        type="number"
                        class="form-control"
                        id="bedrooms"
                        name="bedrooms"
                        min="0"
                      />
                    </div>
                  </div>

                  <!--Bathrooms-->
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="bathrooms">Bathrooms</label>
                      <input
                        type="number"
                        class="form-control"
                        id="bathrooms"
                        name="bathrooms"
                        min="0"
                      />
                    </div>
                  </div>

                  <!--Garages-->
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="garages">Garages</label>
                      <input
                        type="number"
                        class="form-control"
                        id="garages"
                        name="garages"
                        min="0"
                      />
                    </div>
                  </div>
                </div>
                <!--end row-->

                <div id="features-checkboxes" hidden>
                  <h6 class="mb-3">Features</h6>

                  <!--Checkboxes-->
                  <div class="ts-column-count-3">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="ch_1"
                        name="features[]"
                        value="ch_1"
                      />
                      <label class="custom-control-label" for="ch_1"
                        >Air conditioning</label
                      >
                    </div>

                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="ch_2"
                        name="features[]"
                        value="ch_2"
                      />
                      <label class="custom-control-label" for="ch_2"
                        >Bedding</label
                      >
                    </div>

                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="ch_3"
                        name="features[]"
                        value="ch_3"
                      />
                      <label class="custom-control-label" for="ch_3"
                        >Heating</label
                      >
                    </div>

                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="ch_4"
                        name="features[]"
                        value="ch_4"
                      />
                      <label class="custom-control-label" for="ch_4"
                        >Internet</label
                      >
                    </div>

                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="ch_5"
                        name="features[]"
                        value="ch_5"
                      />
                      <label class="custom-control-label" for="ch_5"
                        >Microwave</label
                      >
                    </div>

                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="ch_6"
                        name="features[]"
                        value="ch_6"
                      />
                      <label class="custom-control-label" for="ch_6"
                        >Smoking allowed</label
                      >
                    </div>

                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="ch_7"
                        name="features[]"
                        value="ch_7"
                      />
                      <label class="custom-control-label" for="ch_7"
                        >Terrace</label
                      >
                    </div>

                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="ch_8"
                        name="features[]"
                        value="ch_8"
                      />
                      <label class="custom-control-label" for="ch_8"
                        >Balcony</label
                      >
                    </div>

                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="ch_9"
                        name="features[]"
                        value="ch_9"
                      />
                      <label class="custom-control-label" for="ch_9"
                        >Iron</label
                      >
                    </div>

                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="ch_10"
                        name="features[]"
                        value="ch_10"
                      />
                      <label class="custom-control-label" for="ch_10"
                        >Hi-Fi</label
                      >
                    </div>

                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="ch_11"
                        name="features[]"
                        value="ch_11"
                      />
                      <label class="custom-control-label" for="ch_11"
                        >Beach</label
                      >
                    </div>

                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="ch_12"
                        name="features[]"
                        value="ch_12"
                      />
                      <label class="custom-control-label" for="ch_12"
                        >Parking</label
                      >
                    </div>
                  </div>
                  <!--end ts-column-count-3-->
                </div>
                <!--end #features-checkboxes-->
              </section>
              <!--end #additional-information-->

              <hr />
              <div
                v-for="erroritem in errorlist"
                :key="erroritem.key"
                class="alert alert-danger"
                role="alert"
              >
                {{ erroritem.message }}
              </div>
              <section class="py-3">
                <a href="#" class="btn btn-outline-secondary btn-lg float-left">
                  <i class="fa fa-print mr-2"></i>
                  預覧
                </a>
                <button
                  v-on:click="savesetting"
                  class="btn btn-primary ts-btn-arrow btn-lg float-right"
                >
                  完成
                </button>
              </section>
            </div>
            <!--end #form-submit-->
          </div>
          <!--end offset-lg-1 col-lg-10-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
  </main>
</template>


<script>
import { storage, activityCollection } from "../data/firebase.js";
import mapicon from "../assets/mapicon.png";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import { mapGetters } from "vuex";
// import PulseLoader from "vue-spinners/src/components/FoldSpinner";
import PulseLoader from "./Spinner.vue";
import { readAndCompressImage } from "browser-image-resizer";
import moment from "moment";

// import { gmapApi } from "vue2-google-maps";
const tzoffset = new Date().getTimezoneOffset() * 60000;
export default {
  data: () => ({
    date: new Date(Date.now() - tzoffset).toISOString().substr(0, 10),
    picker1: new Date(Date.now() - tzoffset).toISOString().substr(11, 5),
    picker2: new Date(Date.now() - tzoffset + 60000 * 60)
      .toISOString()
      .substr(11, 5),
    opendatepicker: false,
    openpicker1: false,
    openpicker2: false,
    map: null,
    autocompleteinput: "",
    nowlocation: { lat: 22.302711, lng: 114.177216 },
    nowzoom: 13,
    mapicon: mapicon,
    description: "",
    photourl: "",
    errorlist: [],
    loading: false,
    moment: moment,
  }),
  components: {
    VueGoogleAutocomplete,
    PulseLoader,
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
  created() {},
  mounted() {
    // let myscript = document.createElement("script");
    // myscript.setAttribute(
    //   "src",
    //   "https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyA8HI4yqVXc8EhThX08u6bqO2SB_gPglAs"
    // );
    // document.head.appendChild(myscript);
    // this.map = this.$refs.map;
    // console.log(this.map.$_map);
    // new VueGoogleMap.gmapApi.maps.Map(document.getElementById("inputaddress"));
    // new google.maps.places.Autocomplete(
    //   document.getElementById("inputaddress")
    // );
    // this.$refs.Map2.$MapPromise.then((map) => (this.map = map));
    // this.map = this.$refs.map.$mapObject;
    // this.$refs.map.$mapCreated.then(() => {
    //   this.mapLoaded = true;
    // });
    // console.log(this.google);
    document.getElementById("photoupload").onchange = function () {
      const photoinput = document.getElementById("photoupload");
      console.log(photoinput.files[0]);
      if (photoinput.files && photoinput.files[0]) {
        if (photoinput.files[0].type.indexOf("image") == -1) {
          alert("請上傳照片格式檔案");
          return;
        }
        const config = {
          quality: 0.5,
          maxWidth: 800,
          maxHeight: 600,
          autoRotate: true,
          debug: true,
        };

        // Note: A single file comes from event.target.files on <input>
        readAndCompressImage(photoinput.files[0], config).then(
          (resizedImage) => {
            // Upload file to some Web API
            var reader = new FileReader();
            reader.onload = function (e) {
              document.getElementById("photopreview").src = e.target.result;
            };
            // reader.readAsDataURL(photoinput.files[0]);

            reader.readAsDataURL(resizedImage);
          }
        );
      } else {
        photoinput.src = "";
      }
    };
  },
  methods: {
    handledrag(x) {
      console.log("dragged");
      console.log(x.latLng.lat(), x.latLng.lng());
      this.nowlocation = { lat: x.latLng.lat(), lng: x.latLng.lng() };
    },
    getmylocation() {
      this.$getLocation().then((coordinates) => {
        console.log(coordinates);
        this.nowlocation = coordinates;
      });
    },
    getAddressData: function (x) {
      console.log(x);
      console.log(x.latitude);
      console.log(x.longitude);
      this.nowlocation = { lat: x.latitude, lng: x.longitude };
      this.nowzoom = 16;
    },
    uploadphoto: function (refid, callback) {
      const photoinput = document.getElementById("photoupload");
      const config = {
        quality: 0.7,
        maxWidth: 800,
        maxHeight: 600,
        autoRotate: true,
        debug: true,
      };
      if (photoinput.files[0]) {
        const fileref = storage.child(refid + "/" + photoinput.files[0].name);
        readAndCompressImage(photoinput.files[0], config).then(
          (resizedImage) => {
            fileref
              .put(resizedImage)
              .then((snapshot) => {
                console.log("Uploaded a blob or file!");
                console.log(snapshot);
                fileref.getDownloadURL().then((url) => {
                  console.log(url);
                  this.photourl = url;

                  callback();
                });
              })
              .catch(function (err) {
                console.log(err);
              });
          }
        );
      }
    },
    checktimestringvalid: function (timeStr) {
      var valid =
        timeStr.search(/^\d{2}:\d{2}$/) != -1 &&
        timeStr.substr(0, 2) >= 0 &&
        timeStr.substr(0, 2) <= 24 &&
        timeStr.substr(3, 2) >= 0 &&
        timeStr.substr(3, 2) <= 59;
      return valid;
    },
    savesetting: function () {
      this.errorlist = [];
      var tempsavedata = {
        date: this.date,
        starttime: this.picker1,
        endtime: this.picker2,
        // starttimenumber: new Date(picker1time).getTime(),
        // endtimenumber: new Date(picker2time).getTime(),
        starttimenumber: this.moment(this.date + " " + this.picker1).valueOf(),
        endtimenumber: this.moment(this.date + " " + this.picker2).valueOf(),
        user: this.user.data,
        location: this.nowlocation,
        locationname: this.autocompleteinput,
        zoom: this.nowzoom,
        description: this.description,
      };

      console.log(tempsavedata);

      if (
        tempsavedata.endtimenumber < tempsavedata.starttimenumber ||
        !this.checktimestringvalid(tempsavedata.starttime) ||
        !this.checktimestringvalid(tempsavedata.endtime)
      )
        this.errorlist.push({ message: "請輸入正確的時間", key: "timeerror1" });

      if (
        tempsavedata.date == "" ||
        tempsavedata.starttime == "" ||
        tempsavedata.endtime == "" ||
        tempsavedata.locationname == ""
      ) {
        this.errorlist.push({
          message: "請不要留空動態資料",
          key: "emptyerror1",
        });
      }
      if (this.errorlist.length > 0) return;

      //error checking done
      this.loading = true;
      const self = this;
      activityCollection
        .add(tempsavedata)
        .then(function (ref) {
          console.log(ref.id);
          self.uploadphoto(ref.id, function () {
            activityCollection
              .doc(ref.id)
              .set({ photourl: self.photourl }, { merge: true })
              .then(function () {
                console.log("ok");
                window.location.href = "/";
              });
          });
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    locationnamechange: function (x) {
      console.log(x);
      this.autocompleteinput = x;
    },
    checkpicker1: function () {
      if (!this.checktimestringvalid(this.picker1)) {
        alert("請輸入正確的時間");
      }
    },
    checkpicker2: function () {
      if (!this.checktimestringvalid(this.picker2)) {
        alert("請輸入正確的時間");
      }
    },
  },
};
</script>